import { render, staticRenderFns } from "./ContractCommercialTermsPage.vue?vue&type=template&id=809e2408"
import script from "./ContractCommercialTermsPage.vue?vue&type=script&lang=js"
export * from "./ContractCommercialTermsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports